<!-- 班级出勤率 -->
<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading"
				class="elevation-1" disable-pagination hide-default-footer item-key="classId"
				loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 200px;" class="mr-1">
								<v-select :items="selectClassList" v-model="query.classId" item-text="className"
									item-value="id" label="班级" dense outlined clearable></v-select>
							</div>
							
							<div style="width: 150px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="申请开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
								
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 150px;" class="mr-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="申请结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
								
									</v-date-picker>
								</v-menu>
							</div>
							<v-btn @click="queryClicked" color="primary">查询</v-btn>
						</v-col>
						

					</v-row>
					<v-divider></v-divider>
				</template>
				<template v-slot:item.attendanceRate="{item}">
					<span>{{Number(item.shouldComeCount) > 0 ? (item.realComeCount * 100 / item.shouldComeCount).toFixed(2) : '0.00'}}%</span>
				</template>
				
				
			

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
	//班级出勤率统计
	import utils from "../../../config/utils"
	export default {
		name: "class-attendance-rate",
		components:{},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '数据分析',
						disabled: true
					},
					{
						text: '班级出勤率',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '班级名称',
							value: 'className',
							sortable: false,	
						},
						{
							text: '上课次数',
							value: 'recordCount',
							sortable: false,
						},
						
						{
							text: '应出勤人数',
							value: 'shouldComeCount',
							sortable: false,
										
						},
						{
							text: '实际出勤人数',
							value: 'realComeCount',
							sortable: false,
										
						},
						{
							text: '出勤率',
							value: 'attendanceRate',
							sortable: false,
										
						},
						{
							text: '消课时数',
							value: 'totalReduceQty',
							sortable: false,			
						},
						{
							text: '消课收入',
							value: 'totalRevenue',
							sortable: false,			
						},
					
					],
					list: [],
				},
				selectCourseList: [], //选择课程数据源
				selectClassList: [], //选择课程数据源
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					classId: "",
				},
				
			}
		},
		created() {
			const shopId = utils.getCurrentShopId();
			
			this.query.start = utils.getFirstDayOfMonth();
			this.query.end = utils.getLastDayOfMonth();
			
			this.getClassListForSelect(shopId);
			
			this.getTableDataList();
		},
		methods: {
			
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
		
			getTableDataList() {
				
				if(!this.query.start || !this.query.end){
					this.$noty.error("请选择日期范围");
					return
				}
				
				const diff = utils.diffDate(this.query.start,this.query.end);
				
				console.log(diff);
				
				if (diff > 93){
					this.$noty.error("日期范围最长3个月");
					return
				}
				
				
				const that = this;
				this.query.loading = true;
	
				const shopId = utils.getCurrentShopId();
	
				let url = `/data/class/attendance/rate/${this.query.page}/${this.query.size}?shopId=${shopId}`;
				
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.classId) {
					url += "&classId=" + this.query.classId;
				}
				
				
				this.axios.get(url).then(response => {
	
					console.log(response);
	
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
	
						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			
			getClassListForSelect(shopId) {
	
				if (!shopId) {
					return
				}
	
				const that = this;
				let url = `/edu/shop/class/list/` + shopId;
	
				this.axios.get(url).then(response => {
	
					if (response.data["code"] === 200) {
						that.selectClassList = response.data["data"] ? response.data["data"] : [];
						return
					}
	
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		
	
		}
	}
</script>

<style>
</style>